import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import { useEffect, useState } from "react";
import ReactLoading from "react-loading";
import useApi from "hooks/useApi";

const Summary = ({ filters, search }) => {
  const [salesSummary, setSalesSummary] = useState([]);
  const { loading, fetchData } = useApi();

  useEffect(() => {
    const getSalesSummary = async () => {
      const endpoint = {
        method: "post",
        url: "api/admin/sales/summery",
        data: { ...filters, search },
      };
      const result = await fetchData(endpoint, false);
      setSalesSummary(result?.data || {});
    };
    getSalesSummary();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, filters]);

  return loading ? (
    <Box
      sx={{
        height: "calc(100vh - 145px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <ReactLoading
        type="cylon"
        color="#405189"
        height={"85px"}
        width={"100px"}
      />
    </Box>
  ) : (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
        gap: "20px",
        padding: "20px 20px",
      }}
    >
      {Object.keys(salesSummary).map((singleSales, i) => (
        <Box
          key={i}
          sx={{
            bgcolor: "#fff",
            padding: "20px",
            borderRadius: "5px",
            boxShadow: "2px 1px 3px #e5e5e5",
          }}
        >
          <Typography
            sx={{
              textTransform: "capitalize",
            }}
          >
            {singleSales.split("_").join(" ")}
          </Typography>
          <Typography variant="h3">
            {salesSummary?.[singleSales]}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default Summary;
